declare var dtrum: any;

export const trackSession = (principalId: any, targetId?: any) => {
	try {
		if (typeof dtrum !== 'undefined') {
			if (targetId) {
				dtrum.identifyUser(targetId);
				dtrum.sendSessionProperties(
					null,
					null,
					Object.assign({ target_user: principalId })
				);
			} else {
				dtrum.identifyUser(principalId);
			}
			return true;
		}
	} catch (e) {
		return false;
	}
};
